module.exports = __webpack_public_path__ + "cd6acdc20f8d190179e08e0330f1be27.jpg";